React = require 'react'
l = require 'app/scripts/lib/localize'
{ track } = require '@trello/analytics'
{ unsplashClient } = require '@trello/unsplash'
PhotoAttributionComponent = require 'app/scripts/views/board-create/photo-attribution-component'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

SCROLL_BUFFER = 8 # insert marker X thumbs from the end of the list

module.exports = class extends React.Component
  displayName: 'PhotosList'

  constructor: (props) ->
    super(props)

    @state = {
      uploadingImageID: null
    }

  shouldComponentUpdate: (nextProps, nextState) ->
    { images, isLoading } = @props
    { uploadingImageID } = @state

    (images.length isnt nextProps.images.length) or
    (isLoading isnt nextProps.isLoading) or
    (uploadingImageID isnt nextState.uploadingImageID)

  render: ->
    {
      boardId
      collectionID
      connectionError
      images
      isLoading
      maxPage
      page
    } = @props

    shouldShowMore = maxPage > page
    loadingClass = if isLoading then 'logo-loading active' else 'logo-loading'
    thumbs = images.map(@thumbMap)

    if shouldShowMore
      thumbs = @addMarker(thumbs)

    React.createElement(
      'div'
      { className: 'board-backgrounds-list' }
      (
        if thumbs.length
          thumbs
        else if collectionID is 'search' and not isLoading and not connectionError
          React.createElement('div', { className: 'no-results' }, l(['background photos', 'no results']))
      )
      if connectionError
        React.createElement('div', { className: 'error' }, l(['background photos', 'connection error unsplash']))
      React.createElement('div', { className: loadingClass })
    )

  ###################################################
  # Helper functions ################################
  ###################################################

  thumbMap: (image, index) =>
    { uploadingImageID } = @state

    React.createElement(
      'div',
      {
        className: 'board-background-select',
        key: ['thumb', index, image.id].join(':')
        onClick: @setUnsplashBackground(image)
      },
      React.createElement('span',
        {
          className: 'background-box'
          style:
            backgroundImage: 'url(' + image.urls.thumb + ')'
        },
        if uploadingImageID is image.id
          React.createElement('div', { className: 'uploading' },
            React.createElement('span', { className: 'spinner small u-float-left' })
            l(['templates', 'board_background_selection', 'uploading-ellipsis'])
          )
        else
          React.createElement PhotoAttributionComponent,
            user: image.user,
            size: 'large'
      )
    )

  setUnsplashBackground: (image) -> =>
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ApiPromise = require 'app/scripts/network/api-promise'
    { boardId } = @props

    track('Board Menu', 'Change Background', "unsplash-#{image.id}")
    Analytics.sendUpdatedBoardFieldEvent
      field: 'background',
      value: "unsplash-#{image.id}",
      source: 'boardMenuDrawerBackgroundPhotosScreen',
      containers:
        board:
          id: boardId
      attributes:
        backgroundType: 'photo'


    unsplashClient.trackDownload(image)

    @setState( uploadingImageID: image.id )

    ApiPromise(
      url: "/1/boards/#{boardId}/prefs/background"
      type: 'post'
      data:
        url: unsplashClient.appendImageParameters(image.urls.raw)
    ).finally(=>
      @setState( uploadingImageID: null )
    )

  addMarker: (thumbs) =>
    { registerMarker } = @props

    marker = React.createElement('div',
      key: 'marker'
      className: 'scroll-marker'
      ref: registerMarker
    )
    thumbs.splice(-SCROLL_BUFFER, 0, marker)
    thumbs
